import { PaymentMethod } from '../models/payment-method';
import { StoreBase } from './StoreBase';

export default class PaymentMethodStore extends StoreBase<PaymentMethod> {
  constructor() {
    super('PaymentMethods');
  }

  protected sortItems = (items: PaymentMethod[]) => {
    return items.sort(({ methodName: a }, { methodName: b }) => {
      return a > b ? 1 : a < b ? -1 : 0;
    });
  };

  protected getDisplayText = (item: PaymentMethod) => {
    return item.methodName;
  };
}
